/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconFloppyDisk(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 21 21"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.896 20.793h-2.09a2.69 2.69 0 0 1-2.69-2.69V3.483a2.69 2.69 0 0 1 2.69-2.69h11.487c.16 0 .312.064.425.176l5.221 5.222a.6.6 0 0 1 .177.425v11.487a2.69 2.69 0 0 1-2.69 2.69H4.895M1.754 2.432a1.49 1.49 0 0 1 1.052-.436h1.487v4.62c0 .332.269.602.601.602h8.355a.602.602 0 0 0 0-1.203H5.496V1.996h8.548l4.869 4.87v11.237a1.487 1.487 0 0 1-1.488 1.487h-1.487v-7.752a.6.6 0 0 0-.601-.602H4.894a.6.6 0 0 0-.601.601v7.753H2.806a1.487 1.487 0 0 1-1.487-1.487V3.483c0-.394.156-.772.435-1.051M14.735 19.59h-9.24V12.44h9.24z"
        clipRule="evenodd"
      />
    </svg>
  );
}
